import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { SharedModule } from '../../../shared/shared.module'
import { NewcreditClaimsWithoutOrderComponent } from './newcredit-claims-without-order.component'

@NgModule({
  declarations: [NewcreditClaimsWithoutOrderComponent],
  imports: [CommonModule, RouterModule, UrlModule, SharedModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        newCreditCliam: {
          component: NewcreditClaimsWithoutOrderComponent
        }
      }
    } as CmsConfig)
  ]
})
export class NewcreditClaimsWithoutOrderModule {}
